module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external {"root":"prop-types","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}
// module id = 2
// module chunks = 0